import { FC } from "react";
import { default as TableMUI } from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import { LanguageModel } from "./steps/Step15";

type OptionsModel = {
  value: string;
  descripcion: string;
};

type Props = {
  formik: any;
  languages: LanguageModel[];
  languageLevelArray: OptionsModel[];
  languageArray: OptionsModel[];
  setLanguages: (languages: LanguageModel[]) => void;
  setError: (error: string) => void;
};

const LanguageTable: FC<Props> = (props: Props) => {
  const { formik, languages, languageLevelArray, languageArray, setLanguages, setError } = props;

  const tableRows = [
    { name: "Idioma", isVisible: true },
    { name: "Nivel", isVisible: true },
    { name: "Acciones", isVisible: true },
  ];

  const getLanguageLevelName = (level: string) => {
    const languageLevel = languageLevelArray.find((item: OptionsModel) => item.value === level);
    return languageLevel?.descripcion ?? "loading...";
  };

  const getLanguageName = (language: string) => {
    const languageLevel = languageArray.find((item: OptionsModel) => item.value === language);
    return languageLevel?.descripcion ?? "loading...";
  };

  const removeLanguage = (language: string) => {
    const newLanguages = languages.filter((item: LanguageModel) => item.value !== language);
    setLanguages(newLanguages);
    formik.setFieldValue("languageList", newLanguages);
    setError("");
  };

  return languages?.length && languages[0].value !== "" ? (
    <TableContainer component={Paper} sx={{ maxHeight: 350 }}>
      <TableMUI stickyHeader sx={{ minWidth: 500 }} aria-label='sticky table'>
        <TableHead>
          <TableRow>
            {tableRows?.map(
              ({ name, isVisible }: any) =>
                isVisible && (
                  <TableCell key={name} align='center'>
                    {name}
                  </TableCell>
                )
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {languages?.map((item: LanguageModel, index: number) => (
            <TableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
              <TableCell component='th' scope='row' style={{ minWidth: 50 }} align='center'>
                {`${getLanguageName(item.value)} ${item.anotherOption ? `(${item.anotherOption})` : ""}`}
              </TableCell>
              <TableCell component='th' scope='row' style={{ minWidth: 50 }} align='center'>
                {getLanguageLevelName(item.relatedAnswer)}
              </TableCell>
              <TableCell align='center'>
                <IconButton aria-label='delete' size='small' onClick={() => removeLanguage(item.value)}>
                  <DeleteIcon fontSize='inherit' />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </TableMUI>
    </TableContainer>
  ) : null;
};

export default LanguageTable;
